import { createListenerMiddleware } from "@reduxjs/toolkit";
import ApiService from "../../../services/ApiService.js";
import { actions } from "../model/slice.js";
const listenerMiddleware = createListenerMiddleware();
listenerMiddleware.startListening({
  actionCreator: actions.setApiRoot,
  effect: (action) => {
    ApiService.getInstance().updateConfig({
      baseUrl: action.payload
    });
  }
});
const { middleware } = listenerMiddleware;
export {
  middleware
};
